import { render } from "./ProductsUpdate.vue?vue&type=template&id=0b1b65b5"
import script from "./ProductsUpdate.vue?vue&type=script&lang=js"
export * from "./ProductsUpdate.vue?vue&type=script&lang=js"

import "./ProductsUpdate.vue?vue&type=style&index=0&id=0b1b65b5&lang=scss&scope=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__